import {Component, EventEmitter, Input, Output} from '@angular/core';

/** Asks an organizer for the reason behind a status change, then hands it back; the caller does the work. */
@Component({
    selector: 'app-reason-dialog',
    templateUrl: './reason-dialog.component.html',
    styleUrls: ['./reason-dialog.component.css']
})
export class ReasonDialogComponent {

    @Input() title = '';
    @Input() subtitle = '';
    @Input() message = '';
    @Input() confirmLabel = 'Confirm';
    @Input() busy = false;
    @Input() error = '';
    @Output() confirmed = new EventEmitter<string>();
    @Output() closed = new EventEmitter<void>();

    reason = '';
    attempted = false;

    get reasonMissing(): boolean {
        return this.attempted && !this.reason.trim();
    }

    submit(): void {
        this.attempted = true;
        if (!this.reason.trim() || this.busy) return;
        this.confirmed.emit(this.reason.trim());
    }

    close(): void {
        if (!this.busy) this.closed.emit();
    }
}
